import { render } from "./NovoScanFolheto.vue?vue&type=template&id=77e06479&scoped=true"
import script from "./NovoScanFolheto.vue?vue&type=script&lang=js"
export * from "./NovoScanFolheto.vue?vue&type=script&lang=js"

import "./NovoScanFolheto.vue?vue&type=style&index=0&id=77e06479&scoped=true&lang=css"

import exportComponent from "/home/runner/work/frontend-valora/frontend-valora/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77e06479"]])

export default __exports__